import { render, staticRenderFns } from "./examtype-drawer.vue?vue&type=template&id=c7f7dc18&"
import script from "./examtype-drawer.vue?vue&type=script&lang=js&"
export * from "./examtype-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports